import React, { useState } from "react";
import { X, Mail, BookmarkCheck } from "lucide-react";
import { captureLead } from "@/lib/data";

export default function SaveShortlistModal({ onClose, surgeons }) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const surgeonIds = surgeons?.map(s => s.id) || [];
      await captureLead({ email, source: "shortlist_save", surgeonIds });
      setSuccess(true);
    } catch (err) {
      console.error(err);
      // Fallback
      setSuccess(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-fscs-ink/60 backdrop-blur-sm animate-in fade-in" 
        onClick={onClose}
      />
      <div className="bg-white max-w-md w-full relative z-10 p-8 shadow-2xl animate-in zoom-in-95 fade-in duration-200">
        <button
          onClick={onClose}
          aria-label="Close modal"
          className="absolute top-4 right-4 text-fscs-muted hover:text-fscs-ink transition-colors"
        >
          <X size={20} />
        </button>

        {success ? (
          <div className="text-center py-6">
            <div className="w-14 h-14 bg-emerald-100 text-emerald-600 flex items-center justify-center rounded-full mx-auto mb-5">
              <BookmarkCheck size={28} />
            </div>
            <h3 className="font-display text-2xl mb-3">Shortlist Saved!</h3>
            <p className="text-fscs-muted text-sm">
              We've sent a secure link to your email. You can now access your surgeon shortlist from any device.
            </p>
            <button onClick={onClose} className="btn-outline-ink w-full justify-center mt-8">
              Close
            </button>
          </div>
        ) : (
          <div className="text-center">
            <div className="w-14 h-14 bg-fscs-bg text-fscs-ink flex items-center justify-center rounded-full mx-auto mb-5">
              <Mail size={24} />
            </div>
            <h3 className="font-display text-2xl mb-3">Don't lose your shortlist</h3>
            <p className="text-fscs-muted text-sm mb-8">
              Enter your email address and we'll send you a secure link to access your compared surgeons anytime, anywhere.
            </p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <label htmlFor="shortlistEmail" className="sr-only">Email address</label>
              <input
                id="shortlistEmail"
                type="email"
                required
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 py-3 px-4 w-full border border-fscs-border bg-transparent outline-none text-sm text-fscs-ink focus:border-fscs-coral text-center"
              />
              <button
                type="submit"
                disabled={submitting}
                className="btn-coral w-full justify-center disabled:opacity-60"
              >
                {submitting ? "Saving..." : "Save my shortlist"}
              </button>
              <p className="text-[11px] text-fscs-muted leading-relaxed pt-2">
                By saving, you agree to receive occasional tips and resources from Florida Cosmetic Surgeons. You can unsubscribe at any time.
              </p>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
